import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ brandName }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-gray-900/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-3">
            <img 
              src="/assets/logo-final.png" 
              alt="CréaPrestige" 
              className="h-14 w-auto"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent">
              Créaprestige
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('accueil')}
              className="text-gray-300 hover:text-orange-400 font-medium transition-colors"
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection('pourquoi')}
              className="text-gray-300 hover:text-orange-400 font-medium transition-colors"
            >
              Pourquoi moi
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-300 hover:text-orange-400 font-medium transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('tarifs')}
              className="text-gray-300 hover:text-orange-400 font-medium transition-colors"
            >
              Abonnements
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-300 hover:text-orange-400 font-medium transition-colors"
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-gray-300 hover:text-orange-400 font-medium transition-colors"
            >
              Questions fréquentes
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white rounded-full px-6"
            >
              Devis gratuit
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-blue-600 p-2"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-gray-900 border-t border-gray-800 py-4">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('accueil')}
                className="text-gray-300 hover:text-orange-400 font-medium transition-colors px-4 py-2 text-left"
              >
                Accueil
              </button>
              <button
                onClick={() => scrollToSection('pourquoi')}
                className="text-gray-300 hover:text-orange-400 font-medium transition-colors px-4 py-2 text-left"
              >
                Pourquoi moi
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-gray-300 hover:text-orange-400 font-medium transition-colors px-4 py-2 text-left"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('tarifs')}
                className="text-gray-300 hover:text-orange-400 font-medium transition-colors px-4 py-2 text-left"
              >
                Abonnements
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-300 hover:text-orange-400 font-medium transition-colors px-4 py-2 text-left"
              >
                Contact
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="text-gray-300 hover:text-orange-400 font-medium transition-colors px-4 py-2 text-left"
              >
                Questions fréquentes
              </button>
              <div className="px-4">
                <Button
                  onClick={() => scrollToSection('contact')}
                  className="w-full bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white rounded-full"
                >
                  Devis gratuit
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
